import React from 'react'
import { CardContainer, Description, Title } from './styles'

export interface Props {
  description: string
  title: string
  theme?: 'default' | 'light' | 'negative'
}
/**
 *
 * @deprecated This will be removed in the future. Use Card instead.
 */

const TotalCard: React.FC<Props> = (props: Props) => {
  return (
    <CardContainer theme={props.theme}>
      <Title>{props.title}</Title>
      <Description>{props.description}</Description>
    </CardContainer>
  )
}

export default TotalCard
